export default "__VITE_ASSET__c03598d5__"